<span>Finished export... Your exported file is ready for download.</span>

@if(data(); as data){
    <a [href]="data.url" download rel="noopener" class="primary-text text-decoration-underline ms-1">Download File</a>
}


